import * as React from 'react';

import { Button } from 'components/Button';
import Heading from 'components/Heading';
import Row from 'components/Row';
import Text from 'components/Text';
import Divider from 'components/Divider';
// @ts-ignore
import { PeopleListRow } from 'components/PeopleList/PeopleListTableDataContainer';
import TooltipTrigger from 'components/TooltipTrigger';

import 'components/ListSidebar/styles/ListBatchActions.scss';

type BatchAction = {
  title: string;
  subtext: string;
  onClick: () => void;
  disabled?: boolean;
  tooltip?: string;
  'data-test'?: string;
};

export type Props = {
  actions: BatchAction[];
  rows?: PeopleListRow[];
  onDeselectAll?: () => void;
  children?: React.ReactNode;
};

export default class ListBatchActions extends React.Component<Props> {
  renderDeselectAllButton() {
    const { rows, onDeselectAll } = this.props;

    if (rows && onDeselectAll) {
      return (
        <React.Fragment>
          <div className="ListBatchActions-body">
            <Button color="brand" full level="secondary" onClick={onDeselectAll}>
              Deselect ({rows.length})
            </Button>
          </div>
          <Divider size="flush" />
        </React.Fragment>
      );
    }
  }

  render() {
    const { actions, onDeselectAll, rows } = this.props;

    return (
      <div className="ListBatchActions">
        {this.renderDeselectAllButton()}
        <div className="ListBatchActions-body">
          <Heading level="3">Actions</Heading>
          {actions.map((action, index) => {
            const { disabled, onClick, subtext, tooltip, title } = action;

            const button = (
              <Button
                color="brand"
                level="text"
                full
                data-test={action['data-test']}
                disabled={disabled}
                onClick={onClick}>
                <Heading flush level="4">
                  {title}
                </Heading>
                <Text color="pitch" size="small">
                  {subtext}
                </Text>
              </Button>
            );

            let body = button;

            if (disabled && tooltip) {
              body = (
                <TooltipTrigger key={title} tooltip={tooltip} alignment="left" placement="top">
                  {/* This span is here because disabled buttons don't get mouse
                    * events, and therefore won't be able to activate the tooltip.
                    */}
                  <span>{button}</span>
                </TooltipTrigger>
              );
            }

            return (
              <Row flush={index === actions.length - 1} size="small" key={title}>
                {body}
              </Row>
            );
          })}
        </div>
        {this.props.children}
      </div>
    );
  }
}
